import { AttributeDto, PointsOfInterestDto, Station, TableDto, TakariotSearchRequest, WashStationSearchRequest, postPazomatInstallStationsExportSearchResults, postPointOfInterstsExportSearchResultsOverride, postTakriotsExportSearchResults, postWashStationsExportSearchResults } from "api";
import { InstallationStationsSearchRequest } from "api/api/APIOverride/PazInterfaces";
import { AxiosResponse } from "axios";
import { sectionType } from "components/Pazomat/types";
import FileSaver from "file-saver";
import { generatePDF } from "lib/generatePDF";

export interface YellowMarketStation extends Pick<PointsOfInterestDto, 'Id' | 'Name' | 'PrimaryTelephone' | 'Street' | 'CityName' | 'Location' | 'Distance' | 'CrmId'> {
}

export const hasValidCoords = (item: any): boolean => {
  return (
    (item.Location &&
      item.Location.Latitude !== undefined &&
      item.Location.Longitude !== undefined) ||
    (item.Coordinate &&
      item.Coordinate.Latitude !== undefined &&
      item.Coordinate.Longitude !== undefined)
  )
}

export const getRandomCoordsInIsrael = (): { latitude: number; longitude: number } => {
  // Adjusted bounding box for Israel excluding the Gaza Strip
  const latMin = 31.0 // Northern limit of Gaza Strip is around 31.5, setting a buffer
  const latMax = 33.3
  const lonMin = 34.3
  const lonMax = 35.9

  const randomLatitude = Math.random() * (latMax - latMin) + latMin
  const randomLongitude = Math.random() * (lonMax - lonMin) + lonMin

  return { latitude: randomLatitude, longitude: randomLongitude }
}

/* Function to transform stations data from Locator map to Pazmoat Map */
export const transformStationData = (dataToMap: Station[]): YellowMarketStation[] => {
  const result = dataToMap.map((station: Station, index: number) => {
    const stationInPazmoat: YellowMarketStation = {
      Id: station.id.toString(),
      Name: station.name,
      PrimaryTelephone: station.phone, // ??
      Street: station.address,
      CityName: station.city,
      Location: { // long -> lat lat-> long (adjust api bug)
        Latitude: station.geoLocation.longitude,
        Longitude: station.geoLocation.latitude
      },
      Distance: station.distance, /* double */
      CrmId: index.toString(), // key
    }
    return stationInPazmoat
  })
  return result
}

export type ColumnInfo<T> = {
  key: keyof T;
  description: string;
};

export const generateArrayToPDF = <T>(data: T[], cols: ColumnInfo<T>[]): void => {
  const printArray: TableDto = {
    Header: { Columns: cols.map(col => col.description) },
    Rows: data.map(line => {
      return {
        Columns: cols.map(col => {
          return line[col.key] as string
        })
      }
    }),
    Footer: { Columns: [] },
    SubTitle: "",
    Title: "",
  }
  generatePDF([printArray])
}

export const onDownloadMapGeneric = async <T>(reqBody: T, endpoint: (apiVersion: string, data: T, locale?: string | undefined) => Promise<AxiosResponse<any, any>>, filename: string) => {
  try {
    const response = await endpoint("", reqBody)
    if (response.data) {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      })
      // Use FileSaver to save the file
      FileSaver.saveAs(blob, filename)
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err)
  }
}

type DownloadFunctionMapper = {
  [key in sectionType]: () => void
}

export const createDownloadFuncDict = (searchTerm: string, attrs: AttributeDto[] = []) => {

  const downloadFuncDict: DownloadFunctionMapper = {
    "gaz": () => {
      const reqBody: InstallationStationsSearchRequest = {
        SearchTerm: searchTerm,
        Attributes: attrs,
        Type: "Pazomat",
        MetaData: []

      }
      onDownloadMapGeneric(reqBody, postPointOfInterstsExportSearchResultsOverride, "Reports.xlsx")
    },
    "wash": () => {
      const reqBody: WashStationSearchRequest = {
        SearchTerm: searchTerm,
        Attributes: attrs,
      }
      onDownloadMapGeneric(reqBody, postWashStationsExportSearchResults, "Reports.xlsx")
    },
    "install-orpak": () => {
      const reqBody: InstallationStationsSearchRequest = {
        SearchTerm: searchTerm,
        Attributes: attrs,
        InstallationProvider: "Orpak"
      }
      onDownloadMapGeneric(reqBody, postPazomatInstallStationsExportSearchResults, "Reports.xlsx")
    },
    "install-rozman": () => {
      const reqBody: InstallationStationsSearchRequest = {
        SearchTerm: searchTerm,
        Attributes: attrs,
        InstallationProvider: "Rozman"
      }
      onDownloadMapGeneric(reqBody, postPazomatInstallStationsExportSearchResults, "Reports.xlsx")
    },
    "fix": () => {
      const reqBody: TakariotSearchRequest = {
        SearchTerm: searchTerm,
        Attributes: attrs,
        PageSize: 100,
        RequestPage: 0
      }
      onDownloadMapGeneric(reqBody, postTakriotsExportSearchResults, "Reports.xlsx")
    }
  }
  return downloadFuncDict
}
